// JavaScript used by the unauthenticated website.
//
// Keep this entry point deliberately small: the authenticated application loads
// editors, charts, maps, tables, and other large dependencies that public pages
// do not need.
import "@hotwired/turbo";
import { application } from "./controllers/application";
import registerServiceWorker from "./initializers/register_service_worker";

import AlertDialogController from "./controllers/alert_dialog_controller";
application.register("alert-dialog", AlertDialogController);

import CompareController from "./controllers/compare_controller";
application.register("compare", CompareController);

import ChartLoaderController from "./controllers/chart_loader_controller";
application.register("chart-loader", ChartLoaderController);

import DismissableController from "./controllers/dismissable_controller";
application.register("dismissable", DismissableController);

import FakeNotificationsController from "./controllers/fake_notifications_controller";
application.register("fake-notifications", FakeNotificationsController);

import InputController from "./controllers/input_controller";
application.register("input", InputController);

import RoiCalculatorController from "./controllers/roi_calculator_controller";
application.register("roi-calculator", RoiCalculatorController);

import ScrollRevealController from "./controllers/scroll_reveal_controller";
application.register("scroll-reveal", ScrollRevealController);

import SheetController from "./controllers/sheet_controller";
application.register("sheet", SheetController);

import TemporaryDisplayController from "./controllers/temporary_display_controller";
application.register("temporary-display", TemporaryDisplayController);

import TogglerThemeController from "./controllers/toggler_theme_controller";
application.register("toggler-theme", TogglerThemeController);

registerServiceWorker();
